






































import store from "@/store";
import { CompanyState } from "@/store/company";
import { getProperty } from "@/utils";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NumberInput extends Vue {
  @Prop({ default: "value", required: true, type: String }) value!: string;
  @Prop({ default: 1, required: false, type: Number }) minimum!: number;

  get internalValue(): number {
    return getProperty(
      store.state.company,
      this.value as keyof CompanyState
    ) as number;
  }

  set internalValue(value: number) {
    const val = parseInt(value as unknown as string);
    store.commit.company.setValue({
      name: this.value as keyof CompanyState,
      value: val,
    });
  }

  validate(keypress: KeyboardEvent): void {
    /**
     * Deny non-number inputs
     */
    if (isNaN(parseInt(keypress.key))) {
      keypress.preventDefault();
    }
  }
}
